import { VueSelect, VueSelectOption } from '@ui-common/vue-select';

export default {
	data: () => ({
		year: '',
		itemId: 1
	}),
	components: { VueSelect, VueSelectOption },
	methods: {
		setItemId() {
			this.itemId = this.$refs?.select?.focusedIndex == 0 ? 'item_1' : `item_${this.$refs?.select?.focusedIndex}`;
		}
	},
	mounted() {
		this.setItemId();
	},
	created() {
		this.year = parseInt(window.location.href.split('/').pop());
	},

	watch: {
		year(val, oldVal) {
			if (val && oldVal && val != oldVal) {
				const newurl = window.location.href.split('/').slice(0, -1).join('/') + '/' + val;
				window.location.href = newurl;
			}
		}
	}
};
